import styled from "@emotion/styled";
import { Container, Typography } from "@mui/material";
import { Grid } from "@mui/material";
import { useEffect } from "react";
import AOS from 'aos';
import 'aos/dist/aos.css';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const HeaderContainer = styled(Container)`
    padding-top:20px;
    @media (min-width: 768px){
        min-height:100vh;
    }
    @media (max-width: 749px){
        padding-top:8px;
    }
`
const WrapperContainer = styled(Grid)`
    display: block;

`
const ContentWrapper = styled(Grid)`
`
const VideoBK = styled.video`
    object-fit: cover;
    width: 100%;
    position: absolute;
    z-index: -1;
    @media (min-width: 600px){
        height:100vh;
    }
    @media (max-width: 600px){
        display:none;
        height:100vh;
    }
`
const Videomobile = styled.video`
    object-fit: cover;
    width: 100%;
    position: absolute;
    z-index: -1;
    height:100vh;
    @media (min-width: 600px){
        display:none;
    }
`
const P = styled.p`
    color:#fff;
    font-size:15px;
    font-family:PoppinsR;
    width:644px;
    @media (max-width: 749px){
        width:100%;
        font-size:12px;
    }
    @media (max-width: 1440px) and (min-width: 768px){
        width:480px;
    }
`
const CopyRights = styled.p`
    color:#fff;
    font-size:15px;
    font-family:PoppinsR;
    position:absolute;
    bottom:0;
`
const Heading = styled(Typography)`
    color:#fff;
    font-size:70px;
    font-family:PoppinsB;
    text-transform:uppercase;
    @media (max-width: 749px){
        font-size: 50px;
    }
`
const NavGrid = styled.div`
    background-image: url("./assets/nav-bg.png");
    display: flex;
    justify-content: space-between;
    top: 5%;
    background-size: cover;
    padding:10px 20px;
    @media (min-width: 1440px){
        margin-bottom:50px;
    }
`
const DesktopLogo = styled.img`
    @media (max-width: 1250px) and (min-width: 900px){
    width:150px;
    max-width:100%;
    }
    @media (max-width: 600px){
        width:120px;
        height: auto;
    }
`
const SocialWrapper = styled.div`
    display: flex;
    align-items: center;
    @media (max-width: 900px){
        justify-content:center;
    }
`
const SocialImg = styled.img`
    width:40px;
    max-width:100%;
    height:auto;
    margin:0px 10px 0px 10px;
    @media (max-width: 1250px) and (min-width: 900px){
    width:40px;
    max-width:100%;
    }
    @media (max-width: 900px){
        width:30px;
        height:auto;
        max-width:100%;
    }
`
const SocialA = styled.a`
    display:flex;
    align-items:center;
`
const FieldWrapper = styled.div`
    display: flex;
    border: 1px solid #fff;
    border-radius: 10px;
    align-items: center;
    justify-content: space-between;
    width:644px;
    margin-top:20px;
    @media (max-width: 1440px) and (min-width: 768px){
        width:480px;
    }
    @media (max-width: 749px){
        width:100%;
    }
`
const CopyImg = styled.img`
    height:50px;
    width:50px;
`
const Span = styled.span`
    padding:10px;
    border:none;
        border:none;
        color:#fff;
        font-family:PoppinsS;
        font-size:18px;
        border:none;
    @media (max-width: 749px){
        font-size:13px;
    }
`
const ContractDetails = styled.div`
    width: fit-content;
    margin-top:30px;
    margin-right:20px;
`
const ContractSubH = styled(Typography)`
    color:#FF6414;
    font-size:18;
    font-family:PoppinsS;
    @media (max-width: 600px){
        font-size: 14px;
    }
`
const ContractH = styled(Typography)`
    color:#FFF;
    font-size:22px;
    font-family:PoppinsS;
    @media (max-width: 600px){
        font-size: 18px;
    }
`
const ContractWrapper = styled.div`
    display: flex;
    @media (max-width: 600px){
        display: block;
    }
`
function Header(){
    useEffect(() => {
        AOS.init({duration: 1200,});
      }, [])

      const copyToClipboard = (text) => {
        navigator.clipboard.writeText(text)
          .then(() => {
            toast.success('Contract has been copied');
          })
          .catch((error) => {
            toast.error('Error copying');
            console.error('Error copying text to clipboard:', error);
          });
      };
    
    return(
        <>
            <VideoBK autoPlay loop playsInline muted>
                <source src="./assets/floki_header_final.mp4" type="video/mp4" />
            </VideoBK>
            <Videomobile autoPlay loop playsInline muted>
                <source src="./assets/floki-mobile.mp4" type="video/mp4" />
            </Videomobile>
            <HeaderContainer maxWidth="xl"  id="home">
                <WrapperContainer container>
                    <NavGrid item xs={12}>
                        <div style={{display:"flex"}}>
                            <DesktopLogo src="./assets/logo.png" alt="" />
                        </div>
                        <SocialWrapper>
                            <SocialA href="https://twitter.com/floki30_vip" target="blank"><SocialImg src="./assets/twitter.png" /></SocialA>
                            <SocialA href="https://t.me/floki30" target="blank"><SocialImg src="./assets/telegram.png" /></SocialA>
                        </SocialWrapper>
                    </NavGrid>
                    <ContentWrapper data-aos="fade-right" item xs={12} sm={8} md={6}>
                        <Heading variant="h1">Floki 3.0</Heading>
                        <P >Floki 3.0 has grown tired of countless copycats launching endless degens. 
                            However, for those who may have missed out on the original Floki or Floki 2.0, 
                            here comes the last opportunity to participate in the 3rd and final Floki 3.0. 
                            This launch is scheduled during more reasonable hours, catering to a wider range of 
                            degens and seeking to attract those bold enough to ape in the moment and potentially turn their 
                            humble investments into substantial gains. As the popular saying goes, the third time is indeed the charm.
                        </P>
                    <FieldWrapper>
                        <Span>0xD8590D992d26aC4f78297fA4ca40001ceA5CbEc7</Span>
                        <CopyImg src="./assets/copy.png" onClick={() => copyToClipboard('000xxx0000xxxx000000000xxx')}/>
                    </FieldWrapper>
                    <ContractWrapper>
                        <ContractDetails>
                            <ContractSubH>Symbol</ContractSubH>
                            <ContractH>Floki 3.0</ContractH>
                        </ContractDetails>
                        <ContractDetails>
                            <ContractSubH>Supply</ContractSubH>
                            <ContractH>420,690,000,000,030</ContractH>
                        </ContractDetails>
                        <ContractDetails>
                            <ContractSubH>Taxes</ContractSubH>
                            <ContractH>1/1</ContractH>
                        </ContractDetails>
                    </ContractWrapper>
                    </ContentWrapper>
                </WrapperContainer>
                        <ToastContainer />
                    <CopyRights>© 2023 by Floki 3.0. All rights reserved!</CopyRights>
            </HeaderContainer>
        </>
    );
}

export default Header;